import { SgConnectEnvironment } from 'common/models/SgDashboardProps';
import { Environment } from 'config/environment';

interface ISgConnectConfiguration {
  clientId: string;
  redirectUri: string;
  endpoint: string;
  environment: SgConnectEnvironment;
  scopes: string[];
}

interface IDashboardConfiguration {
  url: string;
  icClientPickerSelectorId: number;
  clientSnapshotBoardId: number;
  topReaderId: number;
  readershipHistoryId: number;
  publicationStatisticsByCategoryId: number;
  activityStatisticsId: number;
  statisticResourceId: string;
  insightResourceId: string;
}

interface IConfiguration {
  baseApiUrls: {
    iam: string;
    ic: string;
    publication: string;
    referential: string;
    requestAccessProxy: string;
    statistic: string;
  };
  // When migrate RequestAccessProxy to RequestAccess
  // baseApiRewriteUrls: {
  //     origin: string,
  //     target: string,
  // }[];
  componentUrls: {
    arclabButtonGroup: string;
    arclabPicker: string;
    arclabSelect: string;
    arclabCheckbox: string;
    idyRequestAccess: string;
  };
  externalUrls: {
    formRequestAccess: (
      returnUrl: string,
      sourceUrl: string,
      sourceContext: string,
    ) => string;
    shared: string;
    insight: string;
  };
  sgConnect: ISgConnectConfiguration;
  sgDashboard: IDashboardConfiguration;
}

const defaultConfiguration = {
  baseApiUrls: {
    iam: 'https://iam-hom.sgmarkets.com',
    ic: 'https://ic-api-hom.fr.world.socgen/2.0',
    publication: 'https://pretrade-api-publication-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
    referential: 'https://pretrade-api-referential-dev.sgmpinsight.dev.euw.gbis.sg-azure.com',
    requestAccessProxy: 'https://sgmarkets-api-request-access-proxy-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
    statistic: 'https://pretrade-api-statistic-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
  },
  // When migrate RequestAccessProxy to RequestAccess
  // baseApiRewriteUrls: [
  //     {
  //         origin: 'https://api-z-dev.sgmarkets.com/uat/services/info/request-access/private/api/',
  //         target: 'https://api-z-dev.sgmarkets.com/uat/services/info/request-access/private/',
  //     },
  //     {
  //         origin: 'https://api-z.sgmarkets.com/services/info/request-access/private/api/',
  //         target: 'https://api-z.sgmarkets.com/services/info/request-access/private/',
  //     },
  // ],
  componentUrls: {
    arclabButtonGroup: 'https://shared.sgmarkets.com/arclab-sg-dashboard/uat/components/arclab-button-group/v1/arclab-button-group.js',
    arclabPicker: 'https://shared.sgmarkets.com/arclab-sg-dashboard/uat/components/arclab-picker/v1/arclab-picker.js',
    arclabSelect: 'https://shared.sgmarkets.com/arclab-sg-dashboard/uat/components/arclab-select/v1/arclab-select.js',
    arclabCheckbox: 'https://shared.sgmarkets.com/arclab-sg-dashboard/uat/components/arclab-checkbox/v2/arclab-checkbox.js',
    idyRequestAccess: 'https://shared-uat.fr.world.socgen/sgidentity/v1/idy-request-access.js',
  },
  externalUrls: {
    formRequestAccess: (
      returnUrl: string,
      sourceUrl: string,
      sourceContext: string,
    ) => `https://info-uat.sgmarkets.com/en/request-access?returnurl=${returnUrl}&sourceurl=${sourceUrl}&sourcecontext=${sourceContext}`,
    insight: 'https://insight-uat.sgmarkets.com',
    shared: 'https://shared-uat.fr.world.socgen',
  },
  sgConnect: {
    clientId: '3bca6af6-ae8b-498f-ba6e-d3f7ad710fd6',
    redirectUri: '/redirect.html',
    endpoint: 'https://sgconnect-hom.fr.world.socgen/sgconnect',
    environment: SgConnectEnvironment.Homologation,
    scopes: [
      'openid',
      'profile',
      'mail',
      'api.manage-commercial-clients.v2',
      'api.statisticdomain.v1',
      'api.idy-widgets.request-access',
      'api.publicationdomain.statistics',
      'api.research-referentials.v1',
      'api.research-referentials.read',
    ],
  },
  sgDashboard: {
    url: 'https://sg-dashboard-dev2.fr.world.socgen',
    icClientPickerSelectorId: 5,
    clientSnapshotBoardId: 93,
    topReaderId: 6033,
    readershipHistoryId: 6032,
    publicationStatisticsByCategoryId: 6031,
    activityStatisticsId: 534,
    statisticResourceId: '095d4949-7605-4097-acf0-6b61d1846cc1',
    insightResourceId: 'eca9968d-02b4-4dc0-a8d8-999408e4cccf',
  },
};

export const configurationPerEnvironment: Record<Environment, IConfiguration> = {
  [Environment.Local]: {
    ...defaultConfiguration,
  },
  [Environment.Development]: {
    ...defaultConfiguration,
  },
  [Environment.Homologation]: {
    ...defaultConfiguration,
    baseApiUrls: {
      iam: 'https://iam-hom.sgmarkets.com',
      ic: 'https://ic-api-hom.fr.world.socgen/2.0',
      publication: 'https://pretrade-api-publication-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
      referential: 'https://pretrade-api-referential-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
      requestAccessProxy: 'https://api-z-dev.sgmarkets.com/uat/services/info/request-access/private',
      statistic: 'https://pretrade-api-statistic-uat.sgmpinsight.dev.euw.gbis.sg-azure.com',
    },
    sgDashboard: {
      url: 'https://sg-dashboard-uat2.fr.world.socgen',
      icClientPickerSelectorId: 5,
      clientSnapshotBoardId: 93,
      topReaderId: 1067,
      readershipHistoryId: 1062,
      publicationStatisticsByCategoryId: 219,
      activityStatisticsId: 4904,
      statisticResourceId: '095d4949-7605-4097-acf0-6b61d1846cc1',
      insightResourceId: 'eca9968d-02b4-4dc0-a8d8-999408e4cccf',
    },
  },
  [Environment.Production]: {
    ...defaultConfiguration,
    baseApiUrls: {
      iam: 'https://iam.sgmarkets.com',
      ic: 'https://api-s.sgmarkets.com/services/ic/crm/v2',
      publication: 'https://pretrade-api-publication-prd.sgmpinsight.prd.euw.gbis.sg-azure.com',
      referential: 'https://pretrade-api-referential-prd.sgmpinsight.prd.euw.gbis.sg-azure.com',
      requestAccessProxy: 'https://api-z.sgmarkets.com/services/info/request-access/private',
      statistic: 'https://pretrade-api-statistic-prd.sgmpinsight.prd.euw.gbis.sg-azure.com',
    },
    componentUrls: {
      arclabButtonGroup: 'https://shared.sgmarkets.com/arclab-sg-dashboard/prd/components/arclab-button-group/v1/arclab-button-group.js',
      arclabPicker: 'https://shared.sgmarkets.com/arclab-sg-dashboard/prd/components/arclab-picker/v1/arclab-picker.js',
      arclabSelect: 'https://shared.sgmarkets.com/arclab-sg-dashboard/prd/components/arclab-select/v1/arclab-select.js',
      arclabCheckbox: 'https://shared.sgmarkets.com/arclab-sg-dashboard/prd/components/arclab-checkbox/v2/arclab-checkbox.js',
      idyRequestAccess: 'https://shared.fr.world.socgen/sgidentity/v1/idy-request-access.js',
    },
    externalUrls: {
      formRequestAccess: (
        returnUrl: string,
        sourceUrl: string,
        sourceContext: string,
      ) => `https://info.sgmarkets.com/en/request-access?returnurl=${returnUrl}&sourceurl=${sourceUrl}&sourcecontext=${sourceContext}`,
      insight: 'https://insight.sgmarkets.com',
      shared: 'https://shared.sgmarkets.com',
    },
    sgConnect: {
      ...defaultConfiguration.sgConnect,
      clientId: 'd9bbdcda-2438-403b-8940-42d9ebf57f1e',
      endpoint: 'https://sso.sgmarkets.com/sgconnect',
      environment: SgConnectEnvironment.Production,
    },
    sgDashboard: {
      url: 'https://dashboard.sgmarkets.com',
      icClientPickerSelectorId: 5,
      clientSnapshotBoardId: 93,
      topReaderId: 2864,
      readershipHistoryId: 2863,
      publicationStatisticsByCategoryId: 2862,
      activityStatisticsId: 6682,
      statisticResourceId: '3c725c4d-f712-4fa4-a7d6-d39dc5524b87',
      insightResourceId: 'f68d4770-05c2-4296-902f-29e4b683f40f',
    },
  },
  [Environment.Test]: {
    ...defaultConfiguration,
  },
};

export const getEnvironment = (): Environment => {
  return window.SGWTWidgetConfiguration?.environment as Environment || Environment.Local;
};

export const configuration = configurationPerEnvironment[getEnvironment()];

export const LATEST_SG_BOOTSTRAP_VERSION = '5.5.1';

export type SgBootstrapTheme = 'standard' | 'dark';
export type SgBootstrapVersion = '4' | '5';